export  const baseAreWeApiUrl = 'http://localhost:3030';

//export const baseKairosApi = 'http://localhost:3030/kairos-api-proxy';